import PropTypes from 'prop-types';
import styles from './Heading.module.css';

/**
 * Heading - Semantic heading component (h1-h6)
 * Use level for semantic HTML, size for visual appearance
 */
export function Heading({
  children,
  level = 2,
  size,
  weight = 'bold',
  color = 'primary',
  align = 'left',
  transform = 'none',
  className = '',
  ...props
}) {
  const Component = `h${level}`;
  const sizeClass = size || `h${level}`;

  const classNames = [
    styles.heading,
    styles[sizeClass],
    styles[weight],
    styles[color],
    styles[align],
    styles[transform],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classNames} {...props}>
      {children}
    </Component>
  );
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  size: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'xs', 'sm', 'md', 'lg', 'xl']),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold', 'bold', 'extrabold', 'black']),
  color: PropTypes.oneOf(['primary', 'secondary', 'muted', 'cyan', 'lime']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  transform: PropTypes.oneOf(['none', 'uppercase', 'lowercase', 'capitalize']),
  className: PropTypes.string,
};

export default Heading;
